<script>import { trackComponent } from "@sentry/svelte";
trackComponent({ "trackInit": true, "trackUpdates": true, "componentName": "NukeSession" });
import * as API from "../../services/api.js";
import { onMount } from "svelte";
onMount(() => {
    API.clearSession();
    localStorage.clear();
    sessionStorage.clear();
    window.location.hash = "";
    location.reload();
    alert("Session cleared successfully!");
});
</script>